import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-892aba70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "section current-water-panel" }
const _hoisted_3 = { class: "section-header section-header-full" }
const _hoisted_4 = { class: "section-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "m", -1))
const _hoisted_6 = { class: "section-footer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "水位変化", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "m", -1))
const _hoisted_10 = { class: "section current-th-panel hide-pc" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header section-header-full" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "設定閾値")
], -1))
const _hoisted_12 = { class: "section-body" }
const _hoisted_13 = { class: "th-value" }
const _hoisted_14 = { class: "section water-history hide-sp" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header section-header-full" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "水位履歴")
], -1))
const _hoisted_16 = { class: "section-body" }
const _hoisted_17 = { class: "time" }
const _hoisted_18 = { class: "history-value" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "m", -1))

import { computed } from 'vue'
import moment from 'moment'
import { camelCase } from 'lodash'
import { useWaterDetailStore } from '@/stores/waterDetailStore'
import { HistoryItem } from '@/models/History'
import { usePresentStore } from '@/stores/presentStore'
import { useGlobalStore } from '@/stores/globalStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { Threshold } from '@/models/InitData'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const waterDetailStore = useWaterDetailStore()
const globalStore = useGlobalStore()
const presentStore = usePresentStore()
const initDataStore = useInitDataStore()
const currentStationId = computed(() => {
  return globalStore.currentStation?.stationId
})
const ap = computed(() => {
  const station = globalStore.currentStation

  return station?.ap
})
const currentWaterTitle = computed(() => {
  return ap.value ? '現在水位AP' : '現在水位'
})
const currentValueText = computed(() => {
  const stationId = currentStationId.value

  if (!stationId) {
    return 0
  }

  let value = presentStore.getValue(stationId, 'waterLevel')

  if (!value) {
    return '-'
  }

  value += ap.value || 0
  const apLabel = ap.value && (value > 0 ? 'AP+' : 'AP')

  return `${ap.value ? apLabel : ''}${value.toFixed(2)}`
})
const diff = computed(() => {
  const stationId = currentStationId.value

  if (!stationId) {
    return 0
  }

  const diff = presentStore.getDiff(stationId, 'waterLevel')

  if (diff === undefined) {
    return '-'
  }

  const result = diff.toFixed(2)

  return result === '-0.00' ? '0.00' : result
})
const history = computed(() => {
  return waterDetailStore.history
})
const timeLabel = (datum: HistoryItem) => {
  return moment(datum.time).format('HH:mm')
}
const formatHistoryValue = (datum: HistoryItem) => {
  if (!datum.waterLevel) {
    return '-'
  }

  const value = datum.waterLevel + (ap.value || 0)

  return value.toFixed(2)
}

const thresholdTitleClass = (th: Threshold) => {
  const alertColors = initDataStore.thresholdColorInfo as Record<string, string>

  if (!alertColors) {
    return ''
  }

  let color = alertColors[camelCase(th.status)]

  if (th.status === 'water_warn3') {
    color = '#898989'
  }

  return { color }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(_unref(currentWaterTitle)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass([_unref(ap) && 'ap-value', "value"])
        }, _toDisplayString(_unref(currentValueText)), 3),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(diff)), 1),
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalStore).waterThreshold, (th) => {
          return (_openBlock(), _createElementBlock("div", {
            key: th.status,
            class: "th-row"
          }, [
            _createElementVNode("span", {
              style: _normalizeStyle(thresholdTitleClass(th)),
              class: "th-title"
            }, _toDisplayString(th.title), 5),
            _createElementVNode("span", _hoisted_13, _toDisplayString(th.comparison) + "m", 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(history), (datum, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `${_unref(currentStationId)}-${index}`
            }, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(timeLabel(datum)), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(formatHistoryValue(datum)), 1),
                _hoisted_20
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})